import { Observable } from 'rxjs'
import { List, Map } from 'immutable'
import { angularActionNameBuilder } from '../dispatchAngular'
import {
  setChannels,
  setRatingTypes,
  setWordCount,
  setToolboxSettings,
} from '../draftEditor'
import { setWebskedDisabled } from '../settingsReducer'

import defaultRatingTypes from '../../modules/directives/ratingPropEditor/types.json'

const toolbarEpic = (action$, store, { serviceResolver }) =>
  action$
    .ofType(angularActionNameBuilder('settings_loaded'))
    .mergeMap((action) => {
      const toolboxItemsPromise = serviceResolver('toolboxService').getItems()
      return Observable.from(toolboxItemsPromise)
        .map(List)
        .mergeMap((toolboxSettings) => {
          return Observable.of(
            setChannels(
              Map(serviceResolver('storyService').channels)
                .map((name, key) => ({ name, key }))
                .toList()
            ),
            setRatingTypes(
              List(action.payload.data.ratingTypes || defaultRatingTypes)
            ),
            setWebskedDisabled(!!action.payload.data.disableWebskedIntegration),
            setToolboxSettings(toolboxSettings)
          )
        })
    })

export default toolbarEpic
